import validate from "/var/lib/jenkins/workspace/검수_finprotection-cli/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/middleware/auth.global.js";
import close_45menu_45global from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/middleware/closeMenu.global.js";
import close_45modal_45global from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/middleware/closeModal.global.js";
import guest_45global from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/middleware/guest.global.js";
import homepage_45global from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/middleware/homepage.global.js";
import manifest_45route_45rule from "/var/lib/jenkins/workspace/검수_finprotection-cli/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  close_45menu_45global,
  close_45modal_45global,
  guest_45global,
  homepage_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}